module.exports = __webpack_public_path__ + "img/antes_despues_14.c03f917b.png";